import { render, staticRenderFns } from "./kyjcProjectView.vue?vue&type=template&id=540e3fc8&scoped=true"
import script from "./kyjcProjectView.vue?vue&type=script&lang=js"
export * from "./kyjcProjectView.vue?vue&type=script&lang=js"
import style0 from "./kyjcProjectView.vue?vue&type=style&index=0&id=540e3fc8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e3fc8",
  null
  
)

export default component.exports